import { API_URL } from '../../../../../../utils/config';

const SUBSCRIBERS_URL = {
  GET_SUBSCRIBERS: `${API_URL}/open5gs/subscribers`,
};

export default SUBSCRIBERS_URL;
